import Header from "./components/Header";
import Hero from "./components/Hero";
import Customers from "./components/Customers";
import About from "./components/About";
import Values from "./components/Values";
import HowItWorks from "./components/HowItWorks";
import Team from "./components/Team";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { DemoModalProvider } from "./context/DemoModalContext";

export default function App() {
  return (
    <DemoModalProvider>
      <Header />
      <main>
        <Hero />
        <Customers />
        <About />
        <Values />
        <HowItWorks />
        <Team />
        <Contact />
      </main>
      <Footer />
    </DemoModalProvider>
  );
}
